// extracted by mini-css-extract-plugin
export default {"container":"FeaturesList_container__8CwL4","row":"FeaturesList_row__imKHo","column":"FeaturesList_column__y3scf","feature":"FeaturesList_feature__pwfE9"};